/* ============================================================
   ZERQUA — Theme JavaScript
   ============================================================ */
(function () {
  'use strict';

  // ── Utilities ────────────────────────────────────────────
  function escHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function formatMoney(cents) {
    var currency = (window.Zerqua && window.Zerqua.currency) || 'EUR';
    var locale   = (window.Zerqua && window.Zerqua.locale)   || 'de-DE';
    return (cents / 100).toLocaleString(locale, { style: 'currency', currency: currency });
  }

  function showToast(msg, type) {
    var toast = document.getElementById('toast');
    if (!toast) return;
    toast.textContent = msg;
    toast.className   = 'toast' + (type ? ' toast--' + type : '');
    toast.classList.add('is-visible');
    setTimeout(function () { toast.classList.remove('is-visible'); }, 3200);
  }
  window.ZerquaToast = showToast;

  // ── Page transition fade-in ───────────────────────────────
  var pageTransition = document.getElementById('page-transition');
  if (pageTransition) {
    // Fade in the page after load
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        pageTransition.classList.add('is-ready');
      });
    });

    // Fade out before navigating away
    document.addEventListener('click', function (e) {
      var link = e.target.closest('a');
      if (!link) return;
      var href = link.getAttribute('href');
      if (!href) return;
      if (
        href.startsWith('#') ||
        href.startsWith('mailto:') ||
        href.startsWith('tel:') ||
        href.startsWith('javascript') ||
        link.target === '_blank' ||
        e.ctrlKey || e.metaKey || e.shiftKey || e.altKey
      ) return;
      // Only intercept same-origin relative links
      if (!href.startsWith('/') && !href.startsWith(window.location.origin)) return;
      e.preventDefault();
      pageTransition.classList.remove('is-ready');
      pageTransition.classList.add('is-leaving');
      setTimeout(function () { window.location.href = href; }, 220);
    });

    // Restore on bfcache restore
    window.addEventListener('pageshow', function (e) {
      if (e.persisted) {
        pageTransition.classList.remove('is-leaving');
        pageTransition.classList.add('is-ready');
      }
    });
  }

  // ── Header scroll effect ──────────────────────────────────
  var header = document.querySelector('.site-header');
  if (header) {
    var onHeaderScroll = function () {
      header.classList.toggle('scrolled', window.scrollY > 10);
    };
    window.addEventListener('scroll', onHeaderScroll, { passive: true });
    onHeaderScroll();
  }

  // ── Back to top ───────────────────────────────────────────
  var backToTop = document.getElementById('back-to-top');
  if (backToTop) {
    backToTop.removeAttribute('hidden');
    var onBttScroll = function () {
      backToTop.classList.toggle('is-visible', window.scrollY > 400);
    };
    window.addEventListener('scroll', onBttScroll, { passive: true });
    backToTop.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
    onBttScroll();
  }

  // ── Cart drawer ───────────────────────────────────────────
  var cartDrawer     = document.getElementById('cart-drawer');
  var cartDrawerBody = document.getElementById('cart-drawer-body');
  var cartCountEls   = document.querySelectorAll('.cart-count');

  function openCart() {
    if (!cartDrawer) return;
    cartDrawer.classList.add('is-open');
    cartDrawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    refreshCart();
  }

  function closeCart() {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('is-open');
    cartDrawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }
  window.closeCartDrawer = closeCart;

  if (cartDrawer) {
    var overlay = cartDrawer.querySelector('.cart-drawer__overlay');
    var closeBtn = cartDrawer.querySelector('.cart-drawer__close');
    if (overlay)  overlay.addEventListener('click', closeCart);
    if (closeBtn) closeBtn.addEventListener('click', closeCart);
  }

  document.querySelectorAll('[data-cart-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function (e) { e.preventDefault(); openCart(); });
  });

  async function refreshCart() {
    try {
      var res  = await fetch('/cart.js');
      if (!res.ok) throw new Error('Cart fetch failed');
      var cart = await res.json();
      updateCartCount(cart.item_count);
      updateShippingProgress(cart.total_price);
      renderCartDrawer(cart);
    } catch (e) {
      console.error('Cart refresh failed', e);
    }
  }

  function updateCartCount(count) {
    cartCountEls.forEach(function (el) {
      el.textContent = count > 0 ? count : '';
      el.setAttribute('data-count', count);
    });
  }

  function updateShippingProgress(totalCents) {
    var progressEl = document.getElementById('cart-shipping-progress');
    if (!progressEl) return;
    var threshold = (window.Zerqua && window.Zerqua.freeShippingThreshold) || 4900;
    var fill = progressEl.querySelector('.cart-shipping-progress__fill');
    var text = progressEl.querySelector('.cart-shipping-progress__text');
    progressEl.hidden = false;
    var pct = Math.min(100, (totalCents / threshold) * 100);
    if (fill) fill.style.width = pct + '%';
    if (text) {
      if (totalCents >= threshold) {
        if (fill) fill.style.background = 'var(--color-success)';
        text.innerHTML = '<strong>You\'ve unlocked free shipping!</strong> &#127881;';
      } else {
        if (fill) fill.style.background = '';
        var remaining = formatMoney(threshold - totalCents);
        text.innerHTML = 'Add <strong>' + remaining + '</strong> more for free shipping';
      }
    }
  }

  function renderCartDrawer(cart) {
    if (!cartDrawerBody) return;

    if (cart.item_count === 0) {
      cartDrawerBody.innerHTML =
        '<div class="cart-drawer__empty">' +
          '<svg class="cart-drawer__empty-icon" width="48" height="48" viewBox="0 0 48 48" fill="none">' +
            '<path d="M10 12h28l-3 18H13L10 12z" stroke="currentColor" stroke-width="1.5" fill="none" stroke-linejoin="round"/>' +
            '<circle cx="18" cy="36" r="2" fill="currentColor"/>' +
            '<circle cx="30" cy="36" r="2" fill="currentColor"/>' +
            '<path d="M4 6h4l2 6" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>' +
          '</svg>' +
          '<p class="cart-drawer__empty-title">Your cart is empty</p>' +
          '<p style="font-size:14px;color:var(--color-text-light)">Discover our products and start shopping.</p>' +
          '<button class="btn btn--primary" onclick="closeCartDrawer()">Continue Shopping</button>' +
        '</div>';
      // Load featured recs asynchronously
      loadEmptyCartRecs();
      return;
    }

    var itemsHTML = cart.items.map(function (item) {
      return '<div class="cart-item" data-key="' + escHtml(item.key) + '">' +
        '<img class="cart-item__image" src="' + escHtml(item.image || '') + '" alt="' + escHtml(item.title) + '" loading="lazy" width="72" height="72">' +
        '<div class="cart-item__body">' +
          '<div class="cart-item__title">' + escHtml(item.product_title) + '</div>' +
          (item.variant_title && item.variant_title !== 'Default Title'
            ? '<div class="cart-item__variant">' + escHtml(item.variant_title) + '</div>' : '') +
          '<div class="cart-item__footer">' +
            '<div class="cart-item__price">' + formatMoney(item.final_line_price) + '</div>' +
            '<div class="qty-control">' +
              '<button class="qty-btn" data-qty-change="' + escHtml(item.key) + '" data-delta="-1" aria-label="Decrease">&#8722;</button>' +
              '<span class="qty-num">' + item.quantity + '</span>' +
              '<button class="qty-btn" data-qty-change="' + escHtml(item.key) + '" data-delta="1" aria-label="Increase">+</button>' +
            '</div>' +
          '</div>' +
          '<button class="cart-item__remove" data-remove="' + escHtml(item.key) + '">Remove</button>' +
        '</div>' +
      '</div>';
    }).join('');

    cartDrawerBody.innerHTML =
      '<div class="cart-items">' + itemsHTML + '</div>' +
      '<div class="cart-discount">' +
        '<form class="cart-discount__form" id="discount-form">' +
          '<input type="text" class="cart-discount__input" id="discount-code-input" placeholder="Discount code" autocomplete="off" spellcheck="false">' +
          '<button type="submit" class="cart-discount__btn">Apply</button>' +
        '</form>' +
        '<div class="cart-discount__msg" id="discount-msg"></div>' +
      '</div>' +
      '<div class="cart-drawer__footer">' +
        '<div class="cart-drawer__subtotal">' +
          '<span class="cart-drawer__subtotal-label">Subtotal</span>' +
          '<span class="cart-drawer__subtotal-price">' + formatMoney(cart.total_price) + '</span>' +
        '</div>' +
        '<p class="cart-drawer__note">Shipping calculated at checkout</p>' +
        '<a href="/checkout" class="btn btn--primary btn--full btn--lg">Checkout &#8594;</a>' +
        '<a href="/cart" class="btn btn--outline btn--full">View Cart</a>' +
      '</div>';

    // Qty buttons
    cartDrawerBody.querySelectorAll('[data-qty-change]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var key   = btn.dataset.qtyChange;
        var delta = parseInt(btn.dataset.delta, 10);
        var item  = cart.items.find(function (i) { return i.key === key; });
        if (!item) return;
        updateCartItem(key, item.quantity + delta);
      });
    });

    // Remove buttons
    cartDrawerBody.querySelectorAll('[data-remove]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        updateCartItem(btn.dataset.remove, 0);
      });
    });

    // Discount code form
    var discountForm = cartDrawerBody.querySelector('#discount-form');
    if (discountForm) {
      discountForm.addEventListener('submit', function (e) {
        e.preventDefault();
        var codeInput = cartDrawerBody.querySelector('#discount-code-input');
        var msgEl     = cartDrawerBody.querySelector('#discount-msg');
        var code = (codeInput && codeInput.value) ? codeInput.value.trim() : '';
        if (!code) return;
        if (msgEl) msgEl.innerHTML = '<span style="color:var(--color-teal)">Applying code at checkout…</span>';
        setTimeout(function () {
          window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=/checkout';
        }, 600);
      });
    }

    // Async upsell injection
    loadCartUpsell(cart);
  }

  async function loadCartUpsell(cart) {
    try {
      var res = await fetch('/collections/all/products.json?limit=8&sort_by=best-selling');
      if (!res.ok) return;
      var data = await res.json();
      var inCartIds = cart.items.map(function (i) { return i.product_id; });
      var upsells = (data.products || [])
        .filter(function (p) { return !inCartIds.includes(p.id); })
        .slice(0, 2);
      if (!upsells.length) return;

      var footer = cartDrawerBody && cartDrawerBody.querySelector('.cart-drawer__footer');
      if (!footer) return;

      var div = document.createElement('div');
      div.className = 'cart-upsell';
      div.innerHTML =
        '<div class="cart-upsell__title">You might also need</div>' +
        '<div class="cart-upsell__items">' +
          upsells.map(function (p) {
            var img    = (p.images && p.images[0]) ? p.images[0].src : '';
            var price  = formatMoney(Math.round(parseFloat((p.variants && p.variants[0] && p.variants[0].price) || 0) * 100));
            var vid    = (p.variants && p.variants[0]) ? p.variants[0].id : '';
            var title  = escHtml(p.title.substring(0, 48));
            return '<div class="cart-upsell__item" data-quick-add="' + vid + '" role="button" tabindex="0">' +
              (img ? '<img class="cart-upsell__img" src="' + escHtml(img) + '" alt="' + title + '" loading="lazy" width="80" height="80">' : '') +
              '<div class="cart-upsell__name">' + title + '</div>' +
              '<div class="cart-upsell__price">' + price + '</div>' +
              '<div class="cart-upsell__add">+ Add</div>' +
            '</div>';
          }).join('') +
        '</div>';

      cartDrawerBody.querySelectorAll('.cart-upsell').forEach(function(el){el.remove();});
      cartDrawerBody.insertBefore(div, footer);
    } catch (e) { /* silent */ }
  }

  async function loadEmptyCartRecs() {
    try {
      var res = await fetch('/collections/all/products.json?limit=3&sort_by=best-selling');
      if (!res.ok) return;
      var data = await res.json();
      var recs = (data.products || []).slice(0, 3);
      if (!recs.length || !cartDrawerBody) return;

      var div = document.createElement('div');
      div.className = 'cart-upsell';
      div.style.borderTop = '1px solid var(--color-border)';
      div.innerHTML =
        '<div class="cart-upsell__title">Popular Products</div>' +
        '<div class="cart-upsell__items cart-upsell__items--3">' +
          recs.map(function (p) {
            var img   = (p.images && p.images[0]) ? p.images[0].src : '';
            var price = formatMoney(Math.round(parseFloat((p.variants && p.variants[0] && p.variants[0].price) || 0) * 100));
            var vid   = (p.variants && p.variants[0]) ? p.variants[0].id : '';
            var title = escHtml(p.title.substring(0, 40));
            return '<div class="cart-upsell__item" data-quick-add="' + vid + '" role="button" tabindex="0">' +
              (img ? '<img class="cart-upsell__img" src="' + escHtml(img) + '" alt="' + title + '" loading="lazy" width="80" height="80">' : '') +
              '<div class="cart-upsell__name">' + title + '</div>' +
              '<div class="cart-upsell__price">' + price + '</div>' +
              '<div class="cart-upsell__add">+ Add</div>' +
            '</div>';
          }).join('') +
        '</div>';

      cartDrawerBody.appendChild(div);
    } catch (e) { /* silent */ }
  }

  async function updateCartItem(key, quantity) {
    try {
      var res = await fetch('/cart/change.js', {
        method:  'POST',
        headers: { 'Content-Type': 'application/json' },
        body:    JSON.stringify({ id: key, quantity: quantity })
      });
      if (!res.ok) throw new Error('Cart update failed');
      var cart = await res.json();
      updateCartCount(cart.item_count);
      updateShippingProgress(cart.total_price);
      renderCartDrawer(cart);
    } catch (e) {
      console.error('Cart update failed', e);
      showToast('Could not update cart', 'error');
    }
  }

  // ── Add to cart (form submit) ─────────────────────────────
  document.addEventListener('submit', async function (e) {
    var form = e.target;
    if (!form.matches('[data-add-to-cart]')) return;
    e.preventDefault();

    var btn          = form.querySelector('[data-atc-btn]');
    var originalHTML = btn ? btn.innerHTML : '';
    if (btn) {
      btn.innerHTML  = 'Adding…';
      btn.disabled   = true;
    }

    try {
      var idInput  = form.querySelector('[name="id"]');
      var qtyInput = form.querySelector('[name="quantity"]');
      var res = await fetch('/cart/add.js', {
        method:  'POST',
        headers: { 'Content-Type': 'application/json' },
        body:    JSON.stringify({
          id:       idInput  ? idInput.value            : null,
          quantity: qtyInput ? parseInt(qtyInput.value, 10) : 1
        })
      });
      if (!res.ok) {
        var errBody = await res.json().catch(function () { return {}; });
        throw new Error(errBody.description || 'Could not add to cart');
      }
      await refreshCart();
      openCart();
      showToast('Added to cart!', 'success');
    } catch (err) {
      showToast(err.message || 'Could not add to cart', 'error');
    } finally {
      if (btn) { btn.innerHTML = originalHTML; btn.disabled = false; }
    }
  });

  // ── Quick-add (product card + cart upsell) ────────────────
  document.addEventListener('click', async function (e) {
    var btn = e.target.closest('[data-quick-add]');
    if (!btn) return;
    e.preventDefault();

    var variantId = btn.dataset.quickAdd;
    if (!variantId) return;

    var originalHTML = btn.innerHTML;
    btn.innerHTML    = '&#8230;';

    try {
      var res = await fetch('/cart/add.js', {
        method:  'POST',
        headers: { 'Content-Type': 'application/json' },
        body:    JSON.stringify({ id: variantId, quantity: 1 })
      });
      if (!res.ok) throw new Error('Add failed');
      await refreshCart();
      openCart();
      showToast('Added to cart!', 'success');
    } catch (e) {
      showToast('Could not add to cart', 'error');
    } finally {
      btn.innerHTML = originalHTML;
    }
  });

  // Quick-add keyboard accessibility
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var btn = e.target.closest('[data-quick-add]');
    if (btn) { e.preventDefault(); btn.click(); }
  });

  // ── Mobile menu ───────────────────────────────────────────
  var mobileMenu    = document.getElementById('mobile-menu');
  var mobileMenuBtn = document.querySelector('[data-mobile-menu]');
  var mobileClose   = document.querySelector('[data-mobile-close]');

  function openMobileMenu() {
    if (!mobileMenu) return;
    mobileMenu.classList.add('is-open');
    mobileMenu.setAttribute('aria-hidden', 'false');
    mobileMenuBtn && mobileMenuBtn.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
  }
  function closeMobileMenu() {
    if (!mobileMenu) return;
    mobileMenu.classList.remove('is-open');
    mobileMenu.setAttribute('aria-hidden', 'true');
    mobileMenuBtn && mobileMenuBtn.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  }

  if (mobileMenuBtn) mobileMenuBtn.addEventListener('click', openMobileMenu);
  if (mobileClose)   mobileClose.addEventListener('click', closeMobileMenu);
  if (mobileMenu) {
    var mmOverlay = mobileMenu.querySelector('.mobile-menu__overlay');
    if (mmOverlay) mmOverlay.addEventListener('click', closeMobileMenu);
  }

  // ── Mobile nav accordion ──────────────────────────────────
  document.querySelectorAll('.mobile-nav-group__toggle').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var expanded = this.getAttribute('aria-expanded') === 'true';
      var children = this.nextElementSibling;
      this.setAttribute('aria-expanded', String(!expanded));
      if (children) {
        children.classList.toggle('is-open', !expanded);
        // Remove HTML hidden attr if present — CSS class controls visibility
        children.removeAttribute('hidden');
      }
    });
  });

  // ── Product gallery ───────────────────────────────────────
  var galleryMain = document.getElementById('gallery-main');
  var mainImg     = galleryMain ? galleryMain.querySelector('img') : null;

  document.querySelectorAll('.product-gallery__thumb').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var full = thumb.dataset.full;
      if (mainImg && full) {
        mainImg.src    = full;
        mainImg.srcset = '';
      }
      document.querySelectorAll('.product-gallery__thumb').forEach(function (t) {
        t.classList.remove('active');
      });
      thumb.classList.add('active');
    });
  });

  // ── Variant selector ──────────────────────────────────────
  document.querySelectorAll('.variant-option').forEach(function (opt) {
    opt.addEventListener('click', function () {
      if (opt.classList.contains('sold-out')) return;
      var group = opt.closest('.variant-options');
      if (!group) return;
      group.querySelectorAll('.variant-option').forEach(function (o) {
        o.classList.remove('active');
      });
      opt.classList.add('active');

      var pos      = opt.dataset.optionPosition;
      var labelEl  = document.getElementById('selected-' + pos);
      if (labelEl) labelEl.textContent = opt.dataset.value;

      // Update hidden variant ID if provided
      var idInput = document.querySelector('[name="id"]');
      if (idInput && opt.dataset.variantId) idInput.value = opt.dataset.variantId;
    });
  });

  // ── Product tabs ──────────────────────────────────────────
  document.querySelectorAll('.product-tab-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var target = btn.dataset.tab;
      document.querySelectorAll('.product-tab-btn').forEach(function (b) { b.classList.remove('active'); });
      document.querySelectorAll('.product-tab-content').forEach(function (c) { c.classList.remove('active'); });
      btn.classList.add('active');
      var panel = document.getElementById(target);
      if (panel) panel.classList.add('active');
    });
  });

  // ── Quantity input validation ──────────────────────────────
  var qtyInput = document.getElementById('product-qty');
  if (qtyInput) {
    qtyInput.addEventListener('change', function () {
      var val = parseInt(this.value, 10);
      if (isNaN(val) || val < 1)  this.value = 1;
      if (val > 10)               this.value = 10;
    });
    qtyInput.addEventListener('blur', function () {
      var val = parseInt(this.value, 10);
      if (isNaN(val) || val < 1) this.value = 1;
      if (val > 10)              this.value = 10;
    });
  }


  // ── Sticky ATC bar (product page) ────────────────────────
  var stickyAtc   = document.getElementById('sticky-atc');
  var productActions = document.getElementById('product-actions');
  if (stickyAtc && productActions && 'IntersectionObserver' in window) {
    var atcObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var visible = !entry.isIntersecting;
        stickyAtc.classList.toggle('is-visible', visible);
        stickyAtc.setAttribute('aria-hidden', String(!visible));
      });
    }, { threshold: 0 });
    atcObserver.observe(productActions);
  }

  // ── Scroll reveal ──────────────────────────────────────────
  if ('IntersectionObserver' in window) {
    var revealObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          revealObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -32px 0px' });

    document.querySelectorAll('.reveal').forEach(function (el) {
      revealObserver.observe(el);
    });
  } else {
    document.querySelectorAll('.reveal').forEach(function (el) {
      el.classList.add('is-visible');
    });
  }

  // ── AJAX live search ──────────────────────────────────────
  var searchInput   = document.querySelector('.header-search__input');
  var searchResults = document.getElementById('search-results');
  var searchTimeout = null;

  if (searchInput && searchResults) {
    searchInput.addEventListener('input', function () {
      clearTimeout(searchTimeout);
      var q = searchInput.value.trim();
      if (q.length < 2) { searchResults.hidden = true; return; }

      searchTimeout = setTimeout(async function () {
        try {
          var res = await fetch(
            '/search/suggest.json?q=' + encodeURIComponent(q) +
            '&resources[type]=product&resources[limit]=5'
          );
          if (!res.ok) throw new Error('Search failed');
          var data     = await res.json();
          var products = (data.resources && data.resources.results && data.resources.results.products) || [];

          if (!products.length) { searchResults.hidden = true; return; }

          searchResults.innerHTML =
            products.map(function (p) {
              var price = p.price ? formatMoney(Math.round(parseFloat(p.price) * 100)) : '';
              var img   = p.image || '';
              return '<a href="' + escHtml(p.url) + '" class="search-result-item">' +
                (img ? '<img class="search-result-item__img" src="' + escHtml(img) + '" alt="' + escHtml(p.title) + '" loading="lazy" width="44" height="44">' : '') +
                '<div>' +
                  '<div class="search-result-item__title">' + escHtml(p.title) + '</div>' +
                  (price ? '<div class="search-result-item__price">' + price + '</div>' : '') +
                '</div>' +
              '</a>';
            }).join('') +
            '<a href="/search?q=' + encodeURIComponent(q) + '&type=product" class="search-results__view-all">View all results for "' + escHtml(q) + '" &rarr;</a>';

          searchResults.hidden = false;

          // Position under the search input
          var rect = searchInput.getBoundingClientRect();
          searchResults.style.left  = rect.left + 'px';
          searchResults.style.top   = (rect.bottom + 4) + 'px';
          searchResults.style.width = Math.max(280, rect.width) + 'px';
        } catch (e) {
          searchResults.hidden = true;
        }
      }, 240);
    });

    document.addEventListener('click', function (e) {
      if (!searchInput.contains(e.target) && !searchResults.contains(e.target)) {
        searchResults.hidden = true;
      }
    });

    searchInput.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { searchResults.hidden = true; searchInput.blur(); }
    });
  }

  // ── Sidebar accordion ─────────────────────────────────────
  document.querySelectorAll('.sidebar__title').forEach(function (title) {
    title.addEventListener('click', function () {
      title.parentElement.classList.toggle('is-collapsed');
    });
  });

  // ── Mobile filter bottom sheet ────────────────────────────
  var filterBottomSheet = document.getElementById('filter-bottom-sheet');

  function openFilterSheet() {
    if (!filterBottomSheet) return;
    filterBottomSheet.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }
  function closeFilterSheet() {
    if (!filterBottomSheet) return;
    filterBottomSheet.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  document.querySelectorAll('[data-filter-toggle]').forEach(function (btn) {
    btn.addEventListener('click', openFilterSheet);
  });

  if (filterBottomSheet) {
    var sheetOverlay = filterBottomSheet.querySelector('.filter-bottom-sheet__overlay');
    var sheetClose   = filterBottomSheet.querySelector('.filter-bottom-sheet__close');
    var sheetApply   = filterBottomSheet.querySelector('.filter-bottom-sheet__apply');
    if (sheetOverlay) sheetOverlay.addEventListener('click', closeFilterSheet);
    if (sheetClose)   sheetClose.addEventListener('click', closeFilterSheet);
    if (sheetApply)   sheetApply.addEventListener('click', closeFilterSheet);
  }

  // ── Load more (collection page) ───────────────────────────
  var loadMoreBtn = document.getElementById('load-more-btn');
  if (loadMoreBtn) {
    loadMoreBtn.addEventListener('click', async function () {
      var nextUrl = loadMoreBtn.dataset.nextUrl;
      if (!nextUrl) return;

      loadMoreBtn.disabled    = true;
      loadMoreBtn.textContent = 'Loading\u2026';

      try {
        var res = await fetch(nextUrl);
        if (!res.ok) throw new Error('Load more failed');
        var html = await res.text();
        var doc  = new DOMParser().parseFromString(html, 'text/html');

        // Extract new product cards
        var newCards = doc.querySelectorAll('.product-grid .product-card');
        var grid     = document.querySelector('.product-grid');
        if (grid && newCards.length) {
          newCards.forEach(function (card) {
            grid.appendChild(card);
            // Reveal new cards
            card.querySelectorAll('.reveal').forEach(function (el) {
              el.classList.add('is-visible');
            });
          });
        }

        // Update or remove the load more button
        var nextBtn = doc.querySelector('#load-more-btn');
        if (nextBtn && nextBtn.dataset.nextUrl) {
          loadMoreBtn.dataset.nextUrl = nextBtn.dataset.nextUrl;
          loadMoreBtn.disabled        = false;
          loadMoreBtn.textContent     = 'Load More';
        } else {
          var wrap = loadMoreBtn.closest('.load-more-wrap');
          if (wrap) wrap.remove();
        }
      } catch (e) {
        loadMoreBtn.disabled    = false;
        loadMoreBtn.textContent = 'Load More';
        showToast('Could not load more products', 'error');
      }
    });
  }

  // ── Init cart count on load ───────────────────────────────
  fetch('/cart.js')
    .then(function (r) { return r.json(); })
    .then(function (cart) { updateCartCount(cart.item_count); })
    .catch(function () {});

  // ── Escape key closes overlays ────────────────────────────
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    closeCart();
    closeMobileMenu();
    closeFilterSheet();
    if (searchResults) searchResults.hidden = true;
  });

})();
